const TURNSTILE_SITE_KEY = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY;
if (!TURNSTILE_SITE_KEY) {
  throw new Error("NEXT_PUBLIC_TURNSTILE_SITE_KEY is not set");
}

export const publicEnv = {
  NEXT_PUBLIC_SITE_URL:
    process.env.NEXT_PUBLIC_SITE_URL || "https://ilussoepito.hu",
  NEXT_PUBLIC_TURNSTILE_SITE_KEY: TURNSTILE_SITE_KEY,
};
